import { DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from '@mui/material';
import type { InvoiceOverview } from '@weft/api-definition';
import { Button } from 'apps/app/src/components/design/buttons/Button/Button';
import { DefaultThemeDialog } from 'apps/app/src/components/design/DefaultThemeDialog';
import { WarningIcon } from 'apps/app/src/components/icons/WarningIcon';
import React from 'react';
import { SyncInvoicesTable } from './sync-invoices-dialog-components/SyncInvoicesTable';

type SyncInvoicesDialogProps = {
  open: boolean;
  onClose: () => void;
  invoices: InvoiceOverview[];
  onSyncInvoices: () => void;
};

export const SyncInvoicesDialog: React.FC<SyncInvoicesDialogProps> = ({ 
  open,
  onClose, 
  invoices,
  onSyncInvoices,
}) => {
  const handleSubmitSync = () => {
    onSyncInvoices();
    onClose();
  };

  return (
    <DefaultThemeDialog
      open={open}
      onClose={onClose}
      fullWidth
      PaperProps={{
        className: 'max-w-[750px] overflow-visible',
      }}
    >
      <DialogTitle>
        Sync
        {' '}
        {invoices.length}
        {' '}
        Invoices With ERP
      </DialogTitle>
      <DialogContent>
        <DialogContentText>Sync 'Approved' invoices with your ERP. </DialogContentText>
      </DialogContent>
      <div className="flex">
        <SyncInvoicesTable
          items={invoices ?? []}
          itemsCount={invoices.length}
        />
      </div>

      <div className="flex items-center gap-x-3 mb-4">
        <WarningIcon width={40}/>
        <Typography>Invoices which are still in 'Draft' or 'In review' workflow cannot be synced just yet.</Typography>
      </div>
      <DialogActions>
        <Button
          variant="text"
          color="secondary"
          onClick={onClose}
        >
          Cancel
        </Button>

        <button
          type="button"
          onClick={handleSubmitSync}
          className="inline-flex justify-center rounded-md border
          border-transparent bg-blue-100 px-4 py-2 text-base font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
        >
          Sync
        </button>
      </DialogActions>

    </DefaultThemeDialog>
  );
};